import { render, staticRenderFns } from "./u-swiper-pagination-text.vue?vue&type=template&id=c1858854&scoped=true&"
import script from "./u-swiper-pagination-text.vue?vue&type=script&lang=js&"
export * from "./u-swiper-pagination-text.vue?vue&type=script&lang=js&"
import style0 from "./u-swiper-pagination-text.vue?vue&type=style&index=0&id=c1858854&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1858854",
  null
  
)

export default component.exports